(function () {
  // ─── CONFIG ───────────────────────────────────────────────
  const ZAR_TO_USD_RATE = 0.054;
  const USD_SYMBOL = 'US$';
  // ──────────────────────────────────────────────────────────

  const storeMode = localStorage.getItem('store_mode');
  if (storeMode !== 'harare') return;

  // ── Read product-level metafield if on a product page ─────
  const metaEl    = document.getElementById('ss-product-meta');
  const metaPrice = metaEl ? parseFloat(metaEl.dataset.hararePrice) : null;
  const hasMetaPrice = metaPrice && !isNaN(metaPrice);

  // ── Formatting ────────────────────────────────────────────
  function formatUSD(amount) {
    return USD_SYMBOL + parseFloat(amount).toFixed(2);
  }

  function convertFromZAR(text) {
    const match = text.match(/R\s*([\d\s,]+\.?\d{0,2})/);
    if (!match) return null;
    const amount = parseFloat(match[1].replace(/[\s,]/g, ''));
    if (isNaN(amount)) return null;
    return formatUSD(amount * ZAR_TO_USD_RATE);
  }

  // ── Convert a single .price element ──────────────────────
  function convertCard(priceEl) {
    // Check card-level metafield (collection grid)
    const card         = priceEl.closest('[data-harare-price]');
    const cardPrice    = card ? parseFloat(card.dataset.hararePrice) : null;
    const useCardPrice = cardPrice && !isNaN(cardPrice);

    // Priority: product page metafield → card metafield → ZAR conversion
    const finalPrice = hasMetaPrice ? metaPrice : (useCardPrice ? cardPrice : null);

    const moneyEls = priceEl.querySelectorAll(
      '.price__container, .price-item, .money, [class*="price__"]'
    );

    if (moneyEls.length > 0) {
      moneyEls.forEach(el => {
        if (finalPrice) {
          el.textContent = formatUSD(finalPrice);
        } else {
          const converted = convertFromZAR(el.textContent);
          if (converted) el.textContent = converted;
        }
      });
      return;
    }

    // Fallback: text nodes
    const walker = document.createTreeWalker(priceEl, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (finalPrice) {
        if (/R\s*[\d]|US\$/.test(node.textContent)) {
          node.textContent = formatUSD(finalPrice);
        }
      } else {
        const converted = convertFromZAR(node.textContent);
        if (converted) node.textContent = converted;
      }
    }
  }

  function convertAllPrices() {
    document.querySelectorAll('.price').forEach(convertCard);
  }

  convertAllPrices();

  // Re-run on dynamic updates
  let processing = false;
  const observer = new MutationObserver(function (mutations) {
    const isOwnMutation = mutations.every(m =>
      Array.from(m.addedNodes).every(n =>
        n.classList && (
          n.classList.contains('ss-store-badge') ||
          n.classList.contains('ss-enquire-nudge')
        )
      )
    );
    if (isOwnMutation || processing) return;
    processing = true;
    requestAnimationFrame(function () {
      convertAllPrices();
      processing = false;
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();